import { Order, OrderStatusEnum } from 'types/graphql';
import { DetailViewActiveTabType } from './DetailView.types';

export const PATH_DETAIL_VIEW_TAB_MAP = (pathname: string): DetailViewActiveTabType => {
  switch (pathname) {
    case '/timesheets':
      return 'TimesheetsTab';
    default:
      return 'GeneralTab';
  }
};

export const isTimesheetsTabAvailable = (order: Order): boolean =>
  !!order.orderSchedule?.timeSheet &&
  [OrderStatusEnum.absent, OrderStatusEnum.completed].includes(order.status.value);

export const getDefaultDetailViewTab = (
  pathname: string,
  order?: Order,
): DetailViewActiveTabType => {
  const defaultTab = PATH_DETAIL_VIEW_TAB_MAP(pathname);
  if (defaultTab === 'TimesheetsTab' && !(order && isTimesheetsTabAvailable(order))) {
    return 'GeneralTab';
  }
  return defaultTab;
};
